export enum VoStatus {
    UnModified,
    New,
    Updated,
    
}